import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SectionHead from "./ui/SectionHead";
import { ArrowUpRight } from "./ui/Icons";

const TYPES = ["ngo", "research", "government", "cooperative"];

const PARTNER_MAILTO =
  "mailto:hyphentechinfo@gmail.com" +
  "?subject=" +
  encodeURIComponent("Partnership enquiry — AgriHyphen AI") +
  "&body=" +
  encodeURIComponent(
    "Hello AgriHyphen team,\n\nOrganisation:\nType (NGO / research / government / cooperative / other):\nCountry or region:\nWhat we would like to work on together:\n\n"
  );

/**
 * Partner and donor call. The four audiences get flat hairline cells — the
 * one card treatment in the system, and the only place on the homepage it is
 * used, so it reads as a distinct move rather than another register.
 */
export default function Partners() {
  const { t } = useTranslation();

  return (
    <section id="partners" className="scroll-mt-24 section bg-agri-paperDeep">
      <div className="container-x">
        <SectionHead
          kicker={t("design.partners.badge")}
          title={t("design.partners.title")}
        >
          {t("design.partners.desc")}
        </SectionHead>

        <ul className="grid grid-cols-1 gap-px bg-agri-rule sm:grid-cols-2">
          {TYPES.map((key, i) => (
            <li key={key} className="bg-agri-card p-7 sm:p-8">
              <span className="font-mono text-[0.6875rem] font-medium tabular-nums text-agri-clay">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="mt-4 font-display text-[1.25rem] font-semibold leading-snug tracking-[-0.018em] text-agri-ink">
                {t(`design.partners.types.${key}.title`)}
              </h3>
              <p className="mt-3 max-w-measure text-[0.9375rem] leading-[1.7] text-agri-ink80">
                {t(`design.partners.types.${key}.desc`)}
              </p>
            </li>
          ))}
        </ul>

        {/* Primary ask: start a conversation */}
        <div className="mt-10 grid grid-cols-1 items-center gap-6 border-t border-agri-rule pt-8 sm:grid-cols-12">
          <p className="max-w-measure text-[0.9375rem] leading-[1.7] text-agri-ink80 sm:col-span-8">
            {t("design.partners.ctaNote")}
          </p>
          <div className="sm:col-span-4 sm:flex sm:justify-end">
            <a href={PARTNER_MAILTO} className="btn-primary">
              {t("design.partners.cta")}
              <ArrowUpRight className="h-3.5 w-3.5" />
            </a>
          </div>
        </div>

        {/* Secondary ask: donors. Set on forest so it separates cleanly from
            the partnership block above without repeating its structure. */}
        <div className="mt-12 bg-agri-forest p-8 sm:p-10 lg:p-12">
          <div className="grid grid-cols-1 items-end gap-8 lg:grid-cols-12">
            <div className="lg:col-span-8">
              <p className="kicker-light">{t("design.partners.donorTitle")}</p>
              <p className="mt-5 max-w-measureWide text-[1.0625rem] leading-[1.7] text-white/70">
                {t("design.partners.donorDesc")}
              </p>
            </div>
            <div className="lg:col-span-4 lg:flex lg:justify-end">
              <Link to="/donate" className="btn-lime">
                {t("design.partners.donorCta")}
                <ArrowUpRight className="h-3.5 w-3.5" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
